import { render, staticRenderFns } from "./PageMethodComponent.vue?vue&type=template&id=57168240&"
import script from "./PageMethodComponent.vue?vue&type=script&lang=js&"
export * from "./PageMethodComponent.vue?vue&type=script&lang=js&"
import style0 from "./PageMethodComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports